import React, {
  useEffect,
  useCallback,
  useState,
  useMemo,
  createContext,
  useContext,
} from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { CHAIN_NAME_MAPPING } from "../constants";

const ChainContext = createContext(null);

function ChainProvider({ children }) {
  const [chainName, setChainName] = useState(undefined);
  const { chain } = useParams();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (chain && CHAIN_NAME_MAPPING[chain]) {
      setChainName(chain);
    }
  }, [chain, setChainName]);

  const changeChainName = useCallback(
    (name) => {
      if (name && name !== chainName && CHAIN_NAME_MAPPING[name]) {
        history.push(location.pathname.replace(chain, name));
      }
    },
    [setChainName, chainName, chain]
  );

  const value = useMemo(
    () => ({
      chainName,
      changeChainName,
    }),
    [chainName, changeChainName]
  );

  return (
    <ChainContext.Provider value={value}>{children}</ChainContext.Provider>
  );
}

const useChain = () => useContext(ChainContext);

export { ChainProvider, useChain };

export default useChain;
